export class ErrorFormat {
	message: string
	supportMessage: string
	errorId: string
	id: string
}

export class ErrorTypeClass {
	private constructor(public value: string) {}
	static warning = new ErrorTypeClass("Warning")
	static IdMismatch = new ErrorTypeClass("id mismatch error")
	static UnauthoriseAccess = new ErrorTypeClass("User is not authorised to manage this data")
	static System = new ErrorTypeClass("There was a server error generated from your request. Please contact the support team.")
	static NotFound = new ErrorTypeClass("The item does not exist")
	static FileUploadError = new ErrorTypeClass("File upload is unsuccessful")
	static FileUploadSuccess = new ErrorTypeClass("File uploaded successfully")
	static InvalidFile = new ErrorTypeClass("File upload is unsuccessful. File is either corrupted or invalid")
	static FileDeletionError = new ErrorTypeClass("File deletion is unsuccessful")
}
